<template>
  <div class="container">
    <img
      src="//static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/zycomlogo.png"
      style="position: absolute; left: -99em"
    />
    <component v-if="shouldShowBar" :is="barComponent" :type="menuType" />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import { isMobile } from '@/utils/utils';
import { BAR_MENU_STATUS } from '@/config';
import Bar from '@/components/Bar';
import BarPC from '@/components/BarPC';
import Footer from '@/components/Footer';
export default {
  name: 'Home',
  components: {
    Bar,
    BarPC,
    Footer
  },
  data() {
    return {
      menuType: BAR_MENU_STATUS.default,
      isMobile: isMobile(),
      Bar,
      BarPC
    };
  },
  computed: {
    /**
     * 判断是否应该显示导航栏组件
     * 移动端：始终显示
     * PC端：除了About页面外都显示
     */
    shouldShowBar() {
      if (this.isMobile) {
        return true; // 移动端始终显示
      }
      return this.$route.name !== 'About'; // PC端除了About页面外都显示
    },
    /**
     * 根据设备类型返回对应的导航栏组件
     */
    barComponent() {
      return this.isMobile ? this.Bar : this.BarPC;
    }
  },
  mounted() {
    this.setMenuStatus();
  },
  methods: {
    setMenuStatus() {
      const { name } = this.$route;
      this.menuType = name === 'Home' ? BAR_MENU_STATUS.scroll : BAR_MENU_STATUS.default;
    }
  },
  watch: {
    $route() {
      this.setMenuStatus();
    }
  }
};
</script>

<style lang="scss">
@import '@/styles/variables.scss';
@import '@/styles/function.scss';
body,
dd,
dl,
h1,
h2,
h3,
h4,
h5,
h6,
ol,
p,
ul {
  margin: 0;
}

a {
  color: inherit;
}

a,
a:hover,
a:active,
a:visited,
a:link,
a:focus {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
  outline: none;
  text-decoration: none;
}

body {
  color: $mainDarkText;
}

.S body {
  overflow-x: hidden;
  overflow: scroll;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.S .container {
  padding-top: rem(120);
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 14px;
  color: #202425;
  min-width: 1280px;
}
</style>
